import { Navigate } from "react-router-dom";

/**
 * Component to determine the default route based on feature flags and user role
 */
export const DefaultRoute = () => {
  return <Navigate to="/dashboard" replace />;
};

/**
 * Component to determine the default OMS route based on feature flags
 */
export const DefaultOmsRoute = () => {
  return <Navigate to="/oms/dashboard" replace />;
};
